import { render } from "./ActivityHistory.vue?vue&type=template&id=6730a82c&scoped=true"
import script from "./ActivityHistory.vue?vue&type=script&lang=js"
export * from "./ActivityHistory.vue?vue&type=script&lang=js"

import "./ActivityHistory.vue?vue&type=style&index=0&id=6730a82c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6730a82c"

export default script